import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Navbar from './components/Navbar/index';
import home from "./pages/home/home.js";
import dashboard from "./pages/dashboard/dashboard";
import about from "./pages/about/about";
import media from "./pages/media/media";
import feedback from "./pages/feedback/feedback";
import login from "./pages/auth/login/login";
import register from "./pages/auth/register/register";
import profile from "./pages/profile/profile";
import testimonials from "./pages/feedback/testimonials.jsx";
import 'bootstrap/dist/css/bootstrap.min.css';

class App extends Component {
  render() {
    return (
      <Router>
        <Navbar />
        <Switch>
          <Route exact path="/" component={home} />
          <Route path="/dashboard" component={dashboard} />
          <Route path="/about" component={about} />
          <Route path="/media" component={media} />
          <Route path="/add-feedback" component={feedback} />
          <Route path="/feedbacks" component={testimonials} />
          <Route path="/login" component={login} />
          <Route path="/register" component={register} />
          <Route path="/profile" component={profile} />
        </Switch>
      </Router>
    );
  }
}

export default App;